<template>
    <div class="filter-size">
        <span v-if="productSize.size.length > 0" class="filter-size__title" v-html="productSize.title"></span>
        <div>
            <div class="filter-size__wrap js-filter-size__wrap-size" :class="[this.sizeShowToggle ? 'open' : '']">
				<span
                    v-for="(size, index) in refactoredSizes"
                    :class="[activeSizes.indexOf(' ' + size.val + ' ') > -1 || activeRanges.indexOf(' ' + size.val + ' ') > -1  ? 'filter-size__item filter-size__item--active': 'filter-size__item', size.range === true ? 'range' : '', size.isStringRange ? 'hide' : '']"
                    @click="triggerFilter(size.val, size.range === true ? 'range' : 'size',$event)"
                    :key="index"
                    :data-name="size.range === true ? 'range' : 'size'" :data-val="size.val"
                    :data-range="size.isStringRange ? 'yes' : 'no'"
                    :data-remove="[activeSizes.indexOf(' ' + size.val + ' ') > -1 || activeRanges.indexOf(' ' + size.val + ' ') > -1]"
                    :data-min="size.min"
                    :data-max="size.max"
                    v-html="size.title"></span>
            </div>
            <a class="filter-size-toggle" href="javascript:;" v-if="this.sapData.productSize[0].size.length > 12" @click="toggleShowMore">
                Show {{ this.sizeShowToggle ? 'Less' : 'More' }}
                <SvgIcon class="filter-size-toggle-icon" :iconName="this.sizeShowToggle ? 'ico-arrow-up': 'ico-arrow-down'"/>
            </a>
        </div>
    </div>
</template>

<script>
import {EventBus} from '@/vue/store';
import Global from '../../../js/_site/global';
import SvgIcon from '../base/SvgIcon/SvgIcon.vue';

export default {
    props: ['productSize'],
    computed: {
        refactoredSizes: function() {
            const sizes = this.productSize.size;
            const arr = [];
            // if (this.sapCategory !== '') {
            //     return sizes;;
            // }
            // if (this.sapColl !== '') {
            //     return sizes;
            // }
            // if (this.sapCategory === 'cabinets') {
            //     return sizes;
            // }
            // if (this.sapCategory === 'vanities') {
            //     return sizes;
            // }
            const isRange = Global.readCookie('isRange');
            if (!isRange) {
                return sizes;
            }
            for (let i = 0; i < sizes.length; i++) {
                if (sizes[i].range === true) {
                    const min = sizes[i].val.split('-')[0];
                    const max = sizes[i].val.split('-')[1];
                    if (parseInt(min) >= sizes[i].min && max <= sizes[i].max) {
                        arr.push(sizes[i]);
                    }
                    arr.push(sizes[i]);
                } else {
                    if (parseInt(sizes[i].val) >= sizes[i].min && parseInt(sizes[i].val) <= sizes[i].max) {
                        arr.push(sizes[i]);
                    }
                }
            }
            return arr;
        },
    },
    methods: {
        triggerFilter(val, name, event) {
            this.scrollToTop();
            if (event.target.classList.contains('filter-size__item--active')) {
                EventBus.$emit('trigger-remove-pill', val, name, event);
            } else {
                this.$emit('filtersLoad', event);
                this.activeFilters = Global.readCookie('activeFilters');
                EventBus.$emit('active-filters', this.activeFilters);
                EventBus.$emit('active-filters-after-remove-size', event.target.getAttribute('data-name'));
                const setPageOne = location.href.replace('/' + this.sapData.pagination.currentPage + '/', '/1/');
                this.sapData.pagination.currentPage = 1;
                window.history.replaceState({}, '', setPageOne);
                EventBus.$emit('get-count', this.sapData.productsCount);
            }
            EventBus.$emit('active-filters-after-remove-size', name);
            EventBus.$emit('check-if-ranges-needed', this.sapCategory, event);
        },
        scrollToTop() {
            const element = document.querySelector('.js-product-listing');
            const elementTop = element.offsetTop;
            const scrollPosition = elementTop - 120;

            window.scroll({
                top: scrollPosition,
                left: 0,
                behavior: 'smooth'
            });
        },
        toggleShowMore() {
            this.sizeShowToggle = !this.sizeShowToggle;
        }
    },
    components: {
        SvgIcon
    },
    data() {
        return {
            activeSizes: Global.checkActive('size'),
            activeRanges: Global.checkActive('range'),
            activeRangesNums: [],
            sizeShowToggle: false,
            // eslint-disable-next-line no-undef
            sapData: sapData,
            // eslint-disable-next-line no-undef
            sapCategory: sapCategory
        };
    },
    created() {
        EventBus.$on('active-filters-after-remove-size', filterName => {
            if (filterName === 'size') {
                this.activeSizes = Global.checkActive(filterName);
            }
            if (filterName === 'range') {
                this.activeRanges = Global.checkActive(filterName);
            }
        });
        EventBus.$on('check-if-ranges-needed', (category, event) => {
            setTimeout(function() {
                const sizes = document.querySelectorAll('.filter-size__item[data-name="size"]');
                for (let i = 0; i < sizes.length; i++) {
                    if (sizes[i].getAttribute('data-range') === 'yes') {
                        sizes[i].classList.add('hide');
                    }
                }
            }, 250);
        });
    },
};
</script>

<style lang="scss" scoped>
.filter-size__title {
    font-size: 12px;
    font-family: $font-second;
    color: $grey;
    text-transform: uppercase;
    letter-spacing: 1.3px;
    margin-bottom: 23px;
    display: block;

    @include mq($md) {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 10px;
    }
}

.filter-size__wrap {
    display: flex;
    flex-wrap: wrap;
    max-width: 200px;
    margin-left: -13px;
    max-height: 188px;
    overflow: hidden;
    height: auto;
    padding: 5px;

    &.open {
        max-height: 1500px;
    }
}

.filter-size-toggle {
    font-size: 12px;
    font-family: $font-second;
    color: $grey;
    font-weight: 400;
    position: relative;
}

.filter-size-toggle-icon {
    height: 12px;
    font-size: 12px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -15px;
}

.filter-size__item {
    height: 38px;
    width: 38px;
    font-size: 14px;
    font-family: $font-second;
    color: #160b00;
    background-color: $white;
    margin-right: 10px;
    margin-bottom: 10px;
    transition: $dur $ease;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    text-align: center;
    border: 1px solid #ddd;

    &:hover {
        background-color: rgba($grey-mid, .1);
        transition: $dur $ease;
        border: 1px solid #ddd;

        @include mq($md) {
            background-color: $grey-mid;
        }
    }

    &.range {
        display: none;
    }

    &.hide {
        display: none;
    }
}

.filter-size__item--active {
    position: relative;

    &::before {
        content: '';
        height: 100%;
        width: 100%;
        border: 1px solid $grey;
        @include center;
        transform: translate(-50%, -50%);
        transition: $dur $ease;
    }

    &:hover {
        background-color: $white;
        transition: $dur $ease;
    }
}
</style>
